import { render, staticRenderFns } from "./ProformTable.vue?vue&type=template&id=453719a5&scoped=true"
import script from "./ProformTable.vue?vue&type=script&lang=js"
export * from "./ProformTable.vue?vue&type=script&lang=js"
import style0 from "./ProformTable.vue?vue&type=style&index=0&id=453719a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453719a5",
  null
  
)

export default component.exports